import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const Checkbox = forwardRef((props, ref) => {
  const { label, id, name, ...rest } = props

  return (
    <React.Fragment>
      <input ref={ref} type="checkbox" id={id ? id : name} name={name} {...rest} />
      <label htmlFor={id ? id : name}>
        <span>{label}</span>
      </label>
    </React.Fragment>
  )
})

Checkbox.displayName = 'Checkbox'

Checkbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}
